/* EKKÓ landing page behaviour. Static asset: Liquid-dependent strings arrive as
   data-* attributes, so this file never needs re-rendering.

   Each [data-ekko-product] card is self-contained and may carry:
     [data-ekko-variants]  variant JSON            (required)
     [data-ekko-prices]    variantId -> price      (money-filter formatted)
     [data-ekko-compares]  variantId -> was-price  (bundles)
     [data-ekko-saves]     variantId -> saving     (bundles)
     [data-ekko-altimages] variantId -> hover src  (spotlight)
     [data-ekko-opt]       option buttons
     [data-ekko-print]     print buttons, sent as the "Prent" line-item property
*/
(function () {
  var PRINT_PROPERTY = 'Prent';

  function init(root) {
    if (root.dataset.ekkoReady === '1') return;
    root.dataset.ekkoReady = '1';

    var currency = root.dataset.ekkoCurrency || 'DKK';
    var rootChoose = root.dataset.ekkoChoose || '';
    var soldOutLabel = root.dataset.ekkoSoldout || '';

    // Fallback only — Liquid supplies the real strings via data-ekko-prices.
    function money(cents) {
      try {
        return new Intl.NumberFormat('da-DK', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    function sized(src, w) {
      if (!src) return null;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function parse(el) {
      if (!el) return {};
      try { return JSON.parse(el.textContent); } catch (e) { return {}; }
    }

    // The theme header is hidden on this template, so park the nav at the top
    // unless some other sticky header is present.
    var navEl = root.querySelector('.ekko-nav');
    function placeNav() {
      if (!navEl || window.matchMedia('(max-width: 900px)').matches) {
        root.style.removeProperty('--ekko-nav-top');
        return;
      }
      var offset = 0;
      document.querySelectorAll('header, .header, [id*="header" i]').forEach(function (h) {
        if (root.contains(h)) return;
        var cs = getComputedStyle(h);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        var r = h.getBoundingClientRect();
        if (r.height > 0 && r.height < 200) offset = Math.max(offset, r.height);
      });
      root.style.setProperty('--ekko-nav-top', offset + 'px');
    }
    placeNav();
    window.addEventListener('resize', placeNav);

    // Narrow header: the links collapse behind a toggle so MERCH can hold the
    // centre of the bar. The panel is CSS-driven off one data attribute, and the
    // button's aria-expanded is the single source of truth for its state.
    var navBar = root.querySelector('.ekko-nav');
    var burger = root.querySelector('[data-ekko-menu-toggle]');
    if (navBar && burger) {
      var setMenu = function (open) {
        navBar.dataset.ekkoMenu = open ? 'open' : 'closed';
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      setMenu(false);
      burger.addEventListener('click', function () {
        setMenu(burger.getAttribute('aria-expanded') !== 'true');
      });
      navBar.querySelectorAll('.ekko-nav__links a').forEach(function (a) {
        a.addEventListener('click', function () { setMenu(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          setMenu(false);
          burger.focus();
        }
      });
      // Widening past the breakpoint would otherwise strand the wide row in the
      // open state, since the panel shares one attribute across both layouts.
      var wide = window.matchMedia('(min-width: 901px)');
      var onWide = function () { if (wide.matches) setMenu(false); };
      if (wide.addEventListener) { wide.addEventListener('change', onWide); }
      else if (wide.addListener) { wide.addListener(onWide); }
    }

    // No theme header means no cart icon; this nav link is the only way to checkout.
    var cartLink = root.querySelector('[data-ekko-cart-link]');
    var cartCount = root.querySelector('[data-ekko-cart-count]');
    function refreshCartLink() {
      if (!cartLink) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cartCount) cartCount.textContent = cart.item_count;
          cartLink.hidden = cart.item_count === 0;
        })
        .catch(function () {});
    }

    root.querySelectorAll('[data-ekko-product]').forEach(function (scope) {
      var variantsEl = scope.querySelector('[data-ekko-variants]');
      if (!variantsEl) return;
      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

      var prices = parse(scope.querySelector('[data-ekko-prices]'));
      var compares = parse(scope.querySelector('[data-ekko-compares]'));
      var saves = parse(scope.querySelector('[data-ekko-saves]'));
      var altImages = parse(scope.querySelector('[data-ekko-altimages]'));

      var idInput = scope.querySelector('[data-ekko-variant-id]');
      var priceEl = scope.querySelector('[data-ekko-price]');
      var compareEl = scope.querySelector('[data-ekko-compare]');
      var saveEl = scope.querySelector('[data-ekko-save]');
      var submit = scope.querySelector('[data-ekko-submit]');
      if (!submit) return;
      var img = scope.querySelector('[data-ekko-img]');
      var altImg = scope.querySelector('[data-ekko-alt-img]');
      var imgWidth = img ? (img.getAttribute('width') || 1000) : 1000;
      var thumbs = [].slice.call(scope.querySelectorAll('[data-ekko-thumb]'));

      var buttons = [].slice.call(scope.querySelectorAll('[data-ekko-opt]'));
      var printButtons = [].slice.call(scope.querySelectorAll('[data-ekko-print]'));
      var positions = [];
      buttons.forEach(function (b) {
        if (positions.indexOf(b.dataset.ekkoOpt) === -1) positions.push(b.dataset.ekkoOpt);
      });
      var swatches = buttons.filter(function (b) { return b.classList.contains('ekko-swatch'); });
      var colourPos = swatches.length ? parseInt(swatches[0].dataset.ekkoOpt, 10) : 0;

      var chooseLabel = submit.getAttribute('data-choose-label') || rootChoose;
      var printLabel = submit.getAttribute('data-print-label') || chooseLabel;
      var readyLabel = submit.getAttribute('data-ready-label');
      var doneLabel = submit.getAttribute('data-done-label');

      var flashTimer = null;
      var lastColour;
      var lastPrint;
      var filterSeen = false;
      var pinned = false;

      function group(pos) {
        return buttons.filter(function (b) { return b.dataset.ekkoOpt === pos; });
      }

      function pressed(list) {
        return list.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || null;
      }

      function selected() {
        var out = [];
        buttons.forEach(function (b) {
          if (b.getAttribute('aria-pressed') === 'true') {
            out[parseInt(b.dataset.ekkoOpt, 10) - 1] = b.dataset.ekkoVal;
          }
        });
        return out;
      }

      function match(sel) {
        return variants.filter(function (v) {
          return sel.every(function (val, i) { return val == null || v.options[i] === val; });
        })[0];
      }

      function allOptionsChosen() {
        return positions.every(function (p) { return !!pressed(group(p)); });
      }

      function chosenPrint() {
        var b = printButtons.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0];
        return b ? b.dataset.ekkoPrint : null;
      }

      // A swatch, or the only value an option has, is never disabled: doing so
      // can strand the shopper, e.g. with XL picked there is no XL in Brunt, so
      // Brunt would grey out with no way back to it.
      function locked(b) {
        return b.classList.contains('ekko-swatch') || group(b.dataset.ekkoOpt).length < 2;
      }

      function markThumb(src) {
        if (!src) return;
        var base = src.split('?')[0];
        thumbs.forEach(function (t) {
          t.setAttribute('aria-pressed', t.dataset.full.split('?')[0] === base ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!img) return;
          pinned = true;
          img.src = t.dataset.full;
          if (t.dataset.alt) img.alt = t.dataset.alt;
          if (altImg) altImg.hidden = true;
          markThumb(t.dataset.full);
        });
      });

      function refresh() {
        var sel = selected();

        buttons.forEach(function (b) {
          if (locked(b)) { b.disabled = false; return; }
          var probe = sel.slice();
          probe[parseInt(b.dataset.ekkoOpt, 10) - 1] = b.dataset.ekkoVal;
          var cand = match(probe);
          b.disabled = !cand || !cand.available;
        });

        var cleared = false;
        buttons.forEach(function (b) {
          if (b.disabled && b.getAttribute('aria-pressed') === 'true') {
            b.setAttribute('aria-pressed', 'false');
            cleared = true;
          }
        });
        if (cleared) sel = selected();

        var deadEnd = positions.some(function (p) {
          return group(p).every(function (b) { return b.disabled; });
        });

        var complete = allOptionsChosen();
        var v = complete ? match(sel) : null;

        if (v) {
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.textContent = prices[v.id] || money(v.price);
          if (compareEl) {
            var c = compares[v.id];
            compareEl.textContent = c || '';
            compareEl.hidden = !c;
          }
          if (saveEl) {
            var s = saves[v.id];
            saveEl.textContent = s || '';
            saveEl.hidden = !s;
          }
        }

        // Shopify can attach a photo to a variant but not to a print, which is
        // a line-item property. So the rail is tagged with both in its alt text
        // and filtered here on whichever of the two the shopper has chosen.
        // With no print picked the rail deliberately shows every print, so the
        // choice is visible before it is made.
        var colourVal = colourPos ? sel[colourPos - 1] : null;
        var printVal = chosenPrint();
        if (!filterSeen || colourVal !== lastColour || printVal !== lastPrint) {
          filterSeen = true;
          lastColour = colourVal;
          lastPrint = printVal;
          pinned = false;
          thumbs.forEach(function (t) {
            var colourMiss = colourVal && t.dataset.colour && t.dataset.colour !== colourVal;
            var printMiss = printVal && t.dataset.print && t.dataset.print !== printVal;
            t.hidden = !!(colourMiss || printMiss);
          });
        }

        var shown = thumbs.filter(function (t) { return !t.hidden; });

        // The photo tracks whatever is chosen so far, so a colour alone swaps it
        // without waiting for a size. The hover image follows along.
        var preview = match(sel);
        if (!pinned && printVal && shown.length) {
          // A print is chosen, so the variant photo may be of the other print.
          // Lead with the first matching shot and pair the hover with the
          // opposite view of the same print, mirroring the spotlight.
          var lead = shown[0];
          if (img && img.getAttribute('src') !== lead.dataset.full) {
            img.src = lead.dataset.full;
            img.alt = lead.dataset.alt || '';
          }
          markThumb(lead.dataset.full);
          if (altImg) {
            var leadAlt = (lead.dataset.alt || '').toLowerCase();
            var wantBack = leadAlt.indexOf('aftan') === -1;
            var pair = shown.filter(function (t) {
              var ta = (t.dataset.alt || '').toLowerCase();
              return t !== lead && (ta.indexOf('aftan') > -1) === wantBack;
            })[0] || shown[1];
            if (pair) {
              if (altImg.getAttribute('src') !== pair.dataset.full) altImg.src = pair.dataset.full;
              altImg.hidden = false;
            } else {
              altImg.hidden = true;
            }
          }
        } else if (preview && !pinned) {
          if (img && preview.featured_image && preview.featured_image.src) {
            var next = sized(preview.featured_image.src, imgWidth);
            if (next && img.getAttribute('src') !== next) {
              img.src = next;
              if (preview.featured_image.alt) img.alt = preview.featured_image.alt;
            }
            markThumb(preview.featured_image.src);
          }
          if (altImg) {
            var back = altImages[preview.id];
            if (back) {
              if (altImg.getAttribute('src') !== back) altImg.src = back;
              altImg.hidden = false;
            } else {
              altImg.hidden = true;
            }
          }
        }

        if (flashTimer) return;
        if (deadEnd) {
          submit.dataset.state = 'idle';
          submit.textContent = soldOutLabel;
        } else if (!complete) {
          submit.dataset.state = 'idle';
          submit.textContent = chooseLabel;
        } else if (printButtons.length && !chosenPrint()) {
          // The print is required, so the button waits rather than arming.
          submit.dataset.state = 'idle';
          submit.textContent = printLabel;
        } else if (!v || !v.available) {
          submit.dataset.state = 'idle';
          submit.textContent = soldOutLabel;
        } else {
          submit.dataset.state = 'ready';
          submit.textContent = readyLabel;
        }
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          group(b.dataset.ekkoOpt).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          refresh();
        });
      });

      printButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          printButtons.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          refresh();
        });
      });

      submit.addEventListener('click', function () {
        if (submit.dataset.state !== 'ready') return;
        var v = match(selected());
        if (!v) return;
        var item = { id: v.id, quantity: 1 };
        var print = chosenPrint();
        if (print) {
          item.properties = {};
          item.properties[PRINT_PROPERTY] = print;
        }
        submit.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          submit.dataset.state = 'added';
          submit.textContent = doneLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          refreshCartLink();
          if (flashTimer) clearTimeout(flashTimer);
          flashTimer = setTimeout(function () { flashTimer = null; refresh(); }, 1500);
        }).catch(function () {
          submit.textContent = 'ORSAKA — TRY AFTUR';
        }).finally(function () {
          submit.disabled = false;
        });
      });

      refresh();
    });

    // The support form stays a real <form>, so it still works with JS off. With
    // JS it joins the same AJAX cart as every other buy button on the page,
    // rather than throwing the donor out of the landing page onto /cart.
    // The "added" wording is borrowed from the merch buttons so there is only
    // one place in the section settings to translate it.
    var supportForm = root.querySelector('.ekko-support__product-form');
    var supportBtn = supportForm && supportForm.querySelector('[type="submit"]');
    if (supportForm && supportBtn) {
      var labelSource = root.querySelector('[data-ekko-submit][data-done-label]');
      var supportIdle = supportBtn.textContent;
      var supportDone = labelSource ? labelSource.getAttribute('data-done-label') : supportIdle;
      var supportTimer = null;
      supportForm.addEventListener('submit', function (e) {
        var sel = supportForm.querySelector('select[name="id"]');
        if (!sel || !sel.value) return;
        e.preventDefault();
        supportBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          supportBtn.textContent = supportDone;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          refreshCartLink();
          if (supportTimer) clearTimeout(supportTimer);
          supportTimer = setTimeout(function () { supportBtn.textContent = supportIdle; }, 1800);
        }).catch(function () {
          supportBtn.textContent = 'ORSAKA — TRY AFTUR';
        }).finally(function () {
          supportBtn.disabled = false;
        });
      });
    }
  }

  function boot() { document.querySelectorAll('.ekko-root').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
